import { useInfiniteQuery } from '@tanstack/react-query'

import API from '@shared/services/src/API'
import { flatten, pageParam, QK } from '@shared/utils'

const LIMIT = 20

export function useScheduledType(type, date) {
  const query = { date: date.format('YYYY-MM-DD'), limit: LIMIT }

  return useInfiniteQuery({
    queryKey: QK.scheduleSlots.providers.scheduled[type].list(query),
    queryFn: ({ pageParam }) => API.scheduleSlots.providers.scheduled[type]({ ...query, offset: pageParam * LIMIT }),
    select: (data) => {
      const providers = data.pages.flat()
      return providers.map((provider) => ({
        ...provider,
        pendingAssessments: provider.pendingAssessments?.map((assessment) => ({
          ...assessment,
          answers: JSON.parse(assessment.answers) || [],
        })),
      }))
    },
    initialPageParam: 0,
    getNextPageParam: pageParam(LIMIT),
  })
}

export function useScheduledUsersType(type, role, date) {
  const query = { role, date: date.format('YYYY-MM-DD'), limit: LIMIT }

  return useInfiniteQuery({
    queryKey: QK.scheduleSlots.users.scheduled[type].list(query),
    queryFn: ({ pageParam }) => API.scheduleSlots.users.scheduled[type]({ ...query, offset: pageParam * LIMIT }),
    select: flatten,
    initialPageParam: 0,
    getNextPageParam: pageParam(LIMIT),
  })
}

export function useUnassignedQHALifestyleMeds() {
  const query = { limit: LIMIT }

  return useInfiniteQuery({
    queryKey: QK.scheduleSlots.providers.unassignedQhaLifestyleMeds.list(query),
    queryFn: ({ pageParam }) => API.scheduleSlots.providers.unassignedQhaLifestyleMeds({ ...query, offset: pageParam * LIMIT }),
    select: flatten,
    initialPageParam: 0,
    getNextPageParam: pageParam(LIMIT),
  })
}
